// extracted by mini-css-extract-plugin
export default {"clearBtn":"IconBtn_clearBtn__1SZYx"};